import {SurveySessionState} from "./SurveySessionModel";

export enum SurveySelectionState {
    pending = "pending",
    executing = "executing",
    completed = "completed",
    error = "error",
}

export function SurveySelectionStateToString(value: SurveySelectionState) {
    switch (value) {
        case SurveySelectionState.pending:
            return "Не выполнялась";
        case SurveySelectionState.executing:
            return "Выполняется";
        case SurveySelectionState.completed:
            return "Выполнена";
        case SurveySelectionState.error:
            return "Ошибка";
    }
}

export function SurveySelectionStateToColor(value: SurveySelectionState) {
    switch (value) {
        case SurveySelectionState.pending:
            return "black";
        case SurveySelectionState.executing:
            return "blue";
        case SurveySelectionState.completed:
            return "green";
        case SurveySelectionState.error:
            return "red";
    }
}

export interface ReferencedItemModel {
    id: string;
    name: string;
}

export interface SurveySelectionModel {
    id: string;
    name: string;
    comment?: string;
    state: SurveySelectionState;
    countIncluded: number;
    createdAt: Date;
    startedAt?: Date;
    finishedAt?: Date;
    conditions: SurveySelectionConditionModel[];
    taskId?: string;
    exportFileId?: string;
    assignSpecialGroupIds?: string[];
    removeSpecialGroupIds?: string[];
}

export enum SurveySelectionConditionAnswerOperator {
    equals = "equals",
    notNull = "notNull",
    isNull = "isNull",
    inList = "inList"
}

export function SurveySelectionConditionAnswerOperatorToString(value: SurveySelectionConditionAnswerOperator) {
    switch (value) {
        case SurveySelectionConditionAnswerOperator.equals:
            return "Ответ равен";
        case SurveySelectionConditionAnswerOperator.notNull:
            return "Есть любой ответ";
        case SurveySelectionConditionAnswerOperator.isNull:
            return "Нет ответа";
        case SurveySelectionConditionAnswerOperator.inList:
            return "Ответ в списке";
    }
}


export enum SurveySelectionConditionAction {
    include = "include",
    exclude = "exclude"
}

export function SurveySelectionConditionActionToString(value: SurveySelectionConditionAction) {
    switch (value) {
        case SurveySelectionConditionAction.include:
            return "Включить в выборку";
        case SurveySelectionConditionAction.exclude:
            return "Исключить из выборки";
    }
}

export interface SurveySelectionConditionAnswerModel {
    question?: ReferencedItemModel;
    operator: SurveySelectionConditionAnswerOperator;
    value?: string;
}

export interface SurveySelectionConditionModel {
    id: number;
    campaign: ReferencedItemModel;
    form: ReferencedItemModel;
    action: SurveySelectionConditionAction;
    answers: SurveySelectionConditionAnswerModel[];
}